import { FeaturesImpl } from '../../base/model/features-impl';
import { AppContext } from '../../base/control/context';

export class PassportData {
  photo: string | null;
  photoHash: string | null;
  typeD: string | null;
  typeP: string | null;
  country: string | null;
  lastName: string | null;
  firstName: string | null;
  serial: string | null;
  nationality: string | null;
  birthDate: string | null;
  gender: string | null;
  validdate: string | null;
}

export class ActivationSetting {
  [key: string]: string | boolean | undefined;
  required?: boolean;
  code?: string;
  mrz2?: string;
  singleMode?: boolean;
  stationaryMode?: boolean;
}

export class VerificationSetting {
  [key: string]: string | boolean | undefined;
  useCheckFingerprints?: boolean;
}

function parseDate(appContext: AppContext, atr: string): string {
  const coolDate = atr.match(/(.{1,2})/gim);
  if (!coolDate) {
    return '';
  }
  if (coolDate[1] == '<<') {
    coolDate[1] = '00';
  }
  if (coolDate[2] == '<<') {
    coolDate[2] = '00';
  }
  let revcoolDate = coolDate.join('-');
  return FeaturesImpl.formatMaskedDate(null, revcoolDate, appContext.getLocale()) || '';
}

function parseGender(appContext: AppContext, atr: any) {
  if (atr == 'M') {
    return appContext.getI18NString('ENUM.Gender.0');
  } else {
    return appContext.getI18NString('ENUM.Gender.1');
  }
}

export function MRZhandler(appContext: AppContext, name: any, mrz88: string) {
  let x = mrz88.substring(0, 44);
  let y = mrz88.substring(44);
  //разбор первой строчки
  name.typeD = x.slice(0, 1); //тип документа
  switch (
    x.slice(1, 2) //тип паспорта
  ) {
    case '<':
      name.typeP = appContext.getI18NString('ENUM.ForeignPassportType.1');
      break;
    case 'D':
      name.typeP = appContext.getI18NString('ENUM.ForeignPassportType.2');
      break;
    case 'S':
      name.typeP = appContext.getI18NString('ENUM.ForeignPassportType.3');
      break;
    default:
      name.typeP = '';
  }
  name.country = x.slice(2, 5); //страна
  let LastNameEnd = x.indexOf('<<');
  let LastName = x.slice(5, LastNameEnd).split('');
  for (let i = 0; i < LastName.length; i++) {
    if (LastName[i] == '<') {
      LastName[i] = ' ';
    }
  }
  name.lastName = LastName.join(''); //фамилия
  let FirstNameEnd = x.indexOf('<<', LastNameEnd + 2);
  let FirstName = x.slice(LastNameEnd + 2, FirstNameEnd).split('');
  for (let i = 0; i < FirstName.length; i++) {
    if (FirstName[i] == '<') {
      FirstName[i] = ' ';
    }
  }
  name.firstName = FirstName.join(''); //имя
  //разбор второй строчки
  name.serial = y.slice(0, 9); //серийный номер
  name.nationality = y.slice(10, 13); //национальность
  name.birthDate = parseDate(appContext, y.slice(13, 19)); //дата рождения
  name.gender = parseGender(appContext, y.slice(20, 21)); //пол
  name.validdate = parseDate(appContext, y.slice(21, 27)); //окончание срока действия паспорта
}
